// here we add all base urls and keys

import {
  appLogoIcon,
  appLogoIcon2,
  danielleLogo,
  hinaKhanLogo,
  danielleSidebarLogo,
} from "src/assets";
import { get_project_info_localStorage } from "src/DAL/localStorage/localStorage";
import { update_root_value } from "src/utils/domUtils";

// Base URLS
export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const project_name = process.env.REACT_APP_PROJECT_NAME;
export const api_key = process.env.REACT_APP_WEB_API_KEY;
export const socketBaseUri = process.env.REACT_APP_API_SOCKET_BASE_URL;
export const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

// export const project_name = "HINA_KHAN";
// export const project_name = "DANIELLE";
// export const project_name = "DD";
const get_project_info = get_project_info_localStorage();
export const material_theme_palate = {
  lighter: "#d4bff2",
  light: "#ede7f6",
  main: "#1a93a9",
  dark: "#198BA8",
  darker: "#198BA8",
  contrastText: "#fff",
};

export const OwnerName = () => {
  if (project_name == "DANIELLE") {
    return "Danielle";
  }
};

export const ownerName = OwnerName() + "'s";
export const ownerCompleteName = OwnerName();

export const get_app_logo = () => {
  if (get_project_info && get_project_info.brand_logo) {
    return s3baseUrl + get_project_info.brand_logo;
  } else {
    if (project_name == "DD") {
      return appLogoIcon;
    } else if (project_name == "HINA_KHAN") {
      return appLogoIcon2;
    } else if (project_name == "DANIELLE") {
      return danielleSidebarLogo;
    } else if (project_name == "BASIC_DEV") {
      return appLogoIcon;
    } else if (project_name == "PGI_DEV") {
      return appLogoIcon;
    }
  }
};

export const get_app_headers = () => {
  if (get_project_info && get_project_info.meta_title) {
    return {
      title: get_project_info.meta_title,
      description: get_project_info.meta_description,
      fav_icon: s3baseUrl + get_project_info.brand_favicon,
    };
  } else {
    if (project_name == "DANIELLE") {
      return {
        title: "DANIELLE | Client",
        description: "DANIELLE | Client",
        fav_icon: appLogoIcon,
      };
    }
  }
};

// if (project_name == "DD") {
//   material_theme_palate.main = "#f6bd4b";
// } else {
//   material_theme_palate.main = "#1a93a9";
// }

if (project_name == "DD") {
  material_theme_palate.main = "#f6bd4b";
  /* Main theme color */
  update_root_value("--portal-theme-primary", "#f6bd4b");
  update_root_value(
    "--portal-theme-primary-filter-color",
    "invert(74%) sepia(96%) saturate(396%) hue-rotate(332deg) brightness(101%) contrast(93%)"
  );

  update_root_value("--portal-theme-secondary", "rgb(255 218 0 / 8%)");
  update_root_value("--text-primary-color", "white");
  update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
  /* Main theme color end */

  /* Main background color*/
  update_root_value("--background-primary-color", "black");
  update_root_value("--background-secondary-color", "#1d1c1d");

  /* Main background color end*/

  /* Sidebar Properties */
  update_root_value("--sidebars-text-color", "white");
  update_root_value("--sidebars-active-color", "#f6bd4b");
  update_root_value("--sidebars-hover-color:", "#f6bd4b");
  update_root_value("--sidebars-background-color", "#1d1c1d");
  /* Sidebar Properties */

  /* Popup / Popover properties  */
  update_root_value("--popup-background-color", "#1d1c1d");
  update_root_value("--popup-text-color", "white");
  /* Popup / Popover properties end  */

  /* Element properties */
  update_root_value("--input-text-color", "#fff");
  update_root_value("--input-placeholder-color", "#fff");
  update_root_value("--input-background-primary", "#1d1c1d");
  update_root_value("--input-background-secondary", "#1d1c1d");
  update_root_value(" --icons-color-allover", "#f6bd4b");
  /* Element properties ends*/

  /* Button Properties */

  update_root_value("--button-background-color", "#1c1c1c");
  update_root_value("--button-text-color", "#f6bd4b");
  update_root_value("--button-outlined-color", "#f6bd4b");
  update_root_value("--button-hover-color", "#f6bd4b");

  /* Button Properties ends*/

  /* Audio Properties */
  update_root_value("--audio-color", "rgb(56, 54, 54)");
  /* Audio Properties ends*/

  /* calendar Properties */
  update_root_value("--calendar-selected-box", "#8b8b8b");
  update_root_value("--datepicker-selected-color", "#fff");
  /* calendar Properties ends*/
} else if (project_name == "BASIC_DEV") {
  material_theme_palate.main = "#f6bd4b";
  /* Main theme color */
  update_root_value("--portal-theme-primary", "#f6bd4b");
  update_root_value(
    "--portal-theme-primary-filter-color",
    "invert(74%) sepia(96%) saturate(396%) hue-rotate(332deg) brightness(101%) contrast(93%)"
  );
  update_root_value("--portal-theme-secondary", "rgb(255 218 0 / 8%)");
  update_root_value("--text-primary-color", "white");
  update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
  /* Main theme color end */

  /* Main background color*/
  update_root_value("--background-primary-color", "black");
  update_root_value("--background-secondary-color", "#1d1c1d");

  /* Main background color end*/

  /* Sidebar Properties */
  update_root_value("--sidebars-text-color", "white");
  update_root_value("--sidebars-active-color", "#f6bd4b");
  update_root_value("--sidebars-hover-color:", "#f6bd4b");
  update_root_value("--sidebars-background-color", "#1d1c1d");
  /* Sidebar Properties */

  /* Popup / Popover properties  */
  update_root_value("--popup-background-color", "#1d1c1d");
  update_root_value("--popup-text-color", "white");
  /* Popup / Popover properties end  */

  /* Element properties */
  update_root_value("--input-text-color", "#fff");
  update_root_value("--input-placeholder-color", "#fff");
  update_root_value("--input-background-primary", "#1d1c1d");
  update_root_value("--input-background-secondary", "#1d1c1d");
  update_root_value(" --icons-color-allover", "#f6bd4b");
  /* Element properties ends*/

  /* Button Properties */

  update_root_value("--button-background-color", "#1c1c1c");
  update_root_value("--button-text-color", "#f6bd4b");
  update_root_value("--button-outlined-color", "#f6bd4b");
  update_root_value("--button-hover-color", "#f6bd4b");

  /* Button Properties ends*/

  /* Audio Properties */
  update_root_value("--audio-color", "rgb(56, 54, 54)");
  /* Audio Properties ends*/

  /* calendar Properties */
  update_root_value("--calendar-selected-box", "#8b8b8b");
  update_root_value("--datepicker-selected-color", "#fff");
  /* calendar Properties ends*/
} else if (project_name == "DANIELLE") {
  material_theme_palate.main = "#C19D60";
  /* Main theme color */
  update_root_value("--portal-theme-primary", "#C19D60");
  update_root_value(
    "--portal-theme-primary-filter-color",
    "invert(69%) sepia(29%) saturate(570%) hue-rotate(359deg) brightness(88%) contrast(92%)"
  );
  update_root_value("--portal-theme-secondary", "rgb(255 218 0 / 8%)");
  update_root_value("--text-primary-color", "white");
  update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
  /* Main theme color end */

  /* Main background color*/
  update_root_value("--background-primary-color", "black");
  update_root_value("--background-secondary-color", "#1d1c1d");

  /* Main background color end*/

  /* Sidebar Properties */
  update_root_value("--sidebars-text-color", "white");
  update_root_value("--sidebars-active-color", "#C19D60");
  update_root_value("--sidebars-hover-color", "#C19D60");
  update_root_value("--sidebars-background-color", "#1d1c1d");
  /* Sidebar Properties */

  /* Popup / Popover properties  */
  update_root_value("--popup-background-color", "#1d1c1d");
  update_root_value("--popup-text-color", "white");
  /* Popup / Popover properties end  */

  /* Element properties */
  update_root_value("--input-text-color", "#fff");
  update_root_value("--input-placeholder-color", "#fff");
  update_root_value("--input-background-primary", "#1d1c1d");
  update_root_value("--input-background-secondary", "#1d1c1d");
  update_root_value(" --icons-color-allover", "#C19D60");
  /* Element properties ends*/

  /* Button Properties */

  update_root_value("--button-background-color", "#1c1c1c");
  update_root_value("--button-text-color", "#C19D60");
  update_root_value("--button-outlined-color", "#C19D60");
  update_root_value("--button-hover-color", "#C19D60");

  /* Button Properties ends*/

  /* Audio Properties */
  update_root_value("--audio-color", "rgb(56, 54, 54)");
  /* Audio Properties ends*/

  /* calendar Properties */
  update_root_value("--calendar-selected-box", "#8b8b8b");
  update_root_value("--datepicker-selected-color", "#fff");
  /* calendar Properties ends*/
} else if (project_name == "PGI_DEV") {
  material_theme_palate.main = "#f6bd4b";
  /* Main theme color */
  update_root_value("--portal-theme-primary", "#f6bd4b");
  update_root_value(
    "--portal-theme-primary-filter-color",
    "invert(74%) sepia(96%) saturate(396%) hue-rotate(332deg) brightness(101%) contrast(93%)"
  );
  update_root_value("--portal-theme-secondary", "rgb(255 218 0 / 8%)");
  update_root_value("--text-primary-color", "white");
  update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
  /* Main theme color end */

  /* Main background color*/
  update_root_value("--background-primary-color", "black");
  update_root_value("--background-secondary-color", "#1d1c1d");

  /* Main background color end*/

  /* Sidebar Properties */
  update_root_value("--sidebars-text-color", "white");
  update_root_value("--sidebars-active-color", "#f6bd4b");
  update_root_value("--sidebars-hover-color:", "#f6bd4b");
  update_root_value("--sidebars-background-color", "#1d1c1d");
  /* Sidebar Properties */

  /* Popup / Popover properties  */
  update_root_value("--popup-background-color", "#1d1c1d");
  update_root_value("--popup-text-color", "white");
  /* Popup / Popover properties end  */

  /* Element properties */
  update_root_value("--input-text-color", "#fff");
  update_root_value("--input-placeholder-color", "#fff");
  update_root_value("--input-background-primary", "#1d1c1d");
  update_root_value("--input-background-secondary", "#1d1c1d");
  update_root_value(" --icons-color-allover", "#f6bd4b");
  /* Element properties ends*/

  /* Button Properties */

  update_root_value("--button-background-color", "#1c1c1c");
  update_root_value("--button-text-color", "#f6bd4b");
  update_root_value("--button-outlined-color", "#f6bd4b");
  update_root_value("--button-hover-color", "#f6bd4b");

  /* Button Properties ends*/

  /* Audio Properties */
  update_root_value("--audio-color", "rgb(56, 54, 54)");
  /* Audio Properties ends*/

  /* calendar Properties */
  update_root_value("--calendar-selected-box", "#8b8b8b");
  update_root_value("--datepicker-selected-color", "#fff");
  /* calendar Properties ends*/
} else {
  material_theme_palate.main = "#1a93a9";
  /* Main theme color */
  update_root_value("--portal-theme-primary", "#1a93a9");
  update_root_value(
    "--portal-theme-primary-filter-color",
    "invert(42%) sepia(98%) saturate(369%) hue-rotate(141deg) brightness(94%) contrast(94%)"
  );
  update_root_value("--portal-theme-secondary", "rgb(0 171 85 / 8%)");
  update_root_value("--text-primary-color", "black");
  update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
  /* Main theme color end */

  /* Main background color*/
  update_root_value("--background-primary-color", "white");
  update_root_value("--background-secondary-color", "white");

  /* Main background color end*/

  /* Sidebar Properties */
  update_root_value("--sidebars-text-color", "black");
  update_root_value("--sidebars-active-color", "#1a93a9");
  update_root_value("--sidebars-hover-color", "#1a93a9");
  update_root_value("--sidebars-background-color", "white");
  /* Sidebar Properties */

  /* Popup / Popover properties  */
  update_root_value("--popup-background-color", "#fff");
  update_root_value("--popup-text-color", "black");
  /* Popup / Popover properties end  */

  /* Element properties */
  update_root_value("--input-text-color", "black");
  update_root_value("--input-placeholder-color", "black"); //not yet
  update_root_value("--input-background-primary", "#fff"); //not yet
  update_root_value("--input-background-secondary", "#EAEAEA");
  update_root_value(" --icons-color-allover", "#f6bd4b");
  /* Element properties ends*/

  /* Button Properties */
  update_root_value("--button-background-color", "#1a93a9");
  update_root_value("--button-text-color", "#fff");
  update_root_value("--button-outlined-color", "#1a93a9");
  update_root_value("--button-hover-color", "#1a93a9");
  /* Button Properties ends*/

  /* Audio Properties */
  update_root_value("--audio-color", "#F1F3F4");
  /* Audio Properties ends*/

  /* calendar Properties */
  update_root_value("--calendar-selected-box", "#8b8b8b");
  update_root_value("--datepicker-selected-color", "#fff");
  /* calendar Properties ends*/
}
